import {  setRequestError, setRequestGetArquivoData, setRequestLoading, setRequestMessage } from "../Reducer/UploadArquivoReducer"
import { RequestResponsePattern } from "../../../../../types/Request"
import { postApi } from "../../../../../utils/requestApi"
import { DOMAIN } from "../../../../../var_env."

import { setAlert } from "../../../../../store/reducers/alert/alertReducer"
import createAlert from "../../../../../scripts/alert/createAlert"
import { uploadArquivo } from "../tipes"

export default async function saveFile(dispatch: Function, data: any){
    try {
        dispatch(setRequestLoading())
        
        const endpoint = `${DOMAIN}/UploadArquivo`
    
        const response: RequestResponsePattern<uploadArquivo> = await postApi({ endpoint, data })

        if(response){
            
            dispatch(setRequestGetArquivoData(response))
            if(!response.flagErro){
                dispatch(setRequestGetArquivoData(response))
                dispatch(setAlert(createAlert('success', 'Arquivo enviado com sucesso')))
                return response.listaResultados
            }
            else throw new Error(response.listaMensagens[0])
        }else throw new Error('Erro na requisição')
    } catch (error: any) {
        dispatch(setRequestMessage(error.message ?? JSON.stringify(error)))
        dispatch(setRequestError())
        dispatch(setAlert(createAlert('error', error.message ?? JSON.stringify(error))))
    }
}